<template>
  <app-base-main
      no-padding
      parentTable
      table-border
      :table-shadow="false"
      style="padding: 10px 0 0;">
    <template #filter-group>
      <app-filter-group
          :isBr="false"
          :reset="false"
          @query="$gjNoticeQuery">
        <app-sp-ad-market-campaign-group-select
            group
            @market-input="filter.marketId = $event"
            @state-input="filter.state = $event"
            @campaign-input="filter.campaignId = $event"
            @group-input="filter.groupId = $event"
        ></app-sp-ad-market-campaign-group-select>
        <gj-input
            v-model="filter.keyword"
            placeholder="投放名称"
            width="100px"
        ></gj-input>
      </app-filter-group>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          :index="false"
          :loading="loading"
          :data="tableData"
          :columns="columns"
          :offset-height="71"
          :pagination="pagination"
          @page-change="$gjNoticeQuery">
        
        <template v-slot:campaignName="{ row }">
          <div class="state-main">
            <gj-tooltip>
              <template #content>
                {{ row.campaignState | state }}
              </template>
              <span :class="`state state-${ row.campaignState }`"></span>
            </gj-tooltip>
            <span>{{ row.campaignName | defaultShow }}</span>
          </div>
        </template>
        <template v-slot:groupName="{ row }">
          <div class="state-main">
            <gj-tooltip>
              <template #content>
                {{ row.groupState | state }}
              </template>
              <span :class="`state state-${ row.groupState }`"></span>
            </gj-tooltip>
            <span>{{ row.groupName | defaultShow }}</span>
          </div>
        </template>
        <template v-slot:targetName="{row}">
          <template v-if="row.resolvedExpressionList && row.resolvedExpressionList.length > 0">
            <gj-tooltip
                v-for="(item, i) in row.resolvedExpressionList"
                :key="i"
                :content="`${item.type}=${item.value}`"
                :text-line="1">
              <template v-if="item.type === 'asinSameAs'">
                asinSameAs=<gj-link :href="row.asinAmazonUrl" target="_blank">{{item.value}}</gj-link>
              </template>
              <template v-else-if="item.type === 'exactProduct'">商品浏览</template>
              <template v-else-if="item.type === 'similarProduct'">类似商品浏览</template>
              <template v-else-if="isMeaningful(item.type) && isMeaningful(item.value)">
                {{item.type}}={{item.value}}
              </template>
              <template v-else>-</template>
            </gj-tooltip>
          </template>
          <template v-else>-</template>
        </template>
        <template v-slot:header:op>
          <gj-button
              type="text"
              @click="addAllItem()">
            添加全部
          </gj-button>
        </template>
        <template v-slot:op="{row}">
          <gj-button
              type="text"
              :disabled="row.addBtnDisabled"
              @click="addItem(row)">
            添加
          </gj-button>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {isMeaningfulMixin, queryMixin} from "../../../../../../../../minxins";
  import {mapGetters} from "vuex";
  import {AdCampaignEnum, AdTargetEnum} from "../../../../../common/enum";
  import {getAdsAdjustStrategyProductTargetUsePage} from "../../../../../../../../api/ad";
  import {isMeaningful, meaningfulEq} from "../../../../../../../../utils/common";
  import {AdStrategyEnum} from "../../../../common/enum";
  import AppSpAdMarketCampaignGroupSelect from "../../../../common/sp-ad-market-campaign-group-select";

  export default {
    name: "app-product-targeting-strategy-tpl-use",
    components: {AppSpAdMarketCampaignGroupSelect},
    mixins: [queryMixin, isMeaningfulMixin],
    props: {
      tpl: {
        required: true
      },
      pickedItems: {
        required: true
      }
    },
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'marketId', header: '站点', field: 'option:marketId', width: '120px', options: () => this.marketOption},
          {id: 'campaignName', header: '广告活动', field: 'slot:campaignName', minWidth: '200px'},
          {id: 'groupName', header: '广告组', field: 'slot:groupName', minWidth: '150px'},
          {id: 'targetName', header: '商品投放', field: 'expressionValue', minWidth: '150px'},
          {id: 'state', header: '广告状态', field: 'option:state', width: '80px', options: AdCampaignEnum.SP.statusOption},
          {id: 'op', header: 'slot:op', field: 'slot:op', width: '80px', fixed: 'right'},
        ],
        filter: {
          marketId: null,
          state: null,
          campaignId: null,
          groupId: null,
          keyword: null
        },
        AdTargetEnum: AdTargetEnum
      }
    },
    watch: {
      unionItems: {
        handler: function ({pickedItems, items}) {
          if (isMeaningful(pickedItems) && isMeaningful(items)) {
            items.forEach(item => {
              const find = pickedItems.some(pickedItem => {
                return (pickedItem.objectType === AdStrategyEnum.objectType.CAMPAIGN && meaningfulEq(item.campaignId, pickedItem.campaignId))
                  || (pickedItem.objectType === AdStrategyEnum.objectType.GROUP && meaningfulEq(item.groupId, pickedItem.groupId))
                  || (pickedItem.objectType === AdStrategyEnum.objectType.PRODUCT_TARGET && meaningfulEq(item.targetId, pickedItem.targetId));
              });
              if (find) {
                this.$set(item, 'addBtnDisabled', true);
              } else {
                this.$set(item, 'addBtnDisabled', false);
              }
            });
          }
        },
        immediate: true
      }
    },
    computed: {
      ...mapGetters({
        marketOption: 'marketOption'
      }),
      unionItems() {
        return {
          pickedItems: this.pickedItems || [],
          items: this.tableData
        }
      }
    },
    filters: {
      state(val) {
        let item = AdCampaignEnum.SP.statusOption.find(e => e.id == val)
        return item ? item.text : val
      }
    },
    methods: {
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            marketId: this.filter.marketId,
            state: this.filter.state,
            campaignId: this.filter.campaignId,
            groupId: this.filter.groupId,
            expressionValue: this.filter.keyword,
            expressionType: '0', // 投放类型：'0'：商品投放，'1'：投放组
          },
          ...this.queryPagination,
          ...this.querySort
        };
        // 查询
        this.loading = true;
        getAdsAdjustStrategyProductTargetUsePage(params)
          .then((data) => {
            const tableData = (data.records || []);
            tableData.forEach(e => {
              try {
                e.resolvedExpressionList = JSON.parse(e.expression);
              } catch (e) {
                e.resolvedExpressionList = [];
              }
            });
            this.tableData = tableData;
            this.pagination = this.getPagination(data);
          })
          .complete(() => this.loading = false);
      },
      addAllItem() {
        const rows = (this.tableData || []).filter(item => !item.addBtnDisabled);
        if (rows.length > 0) {
          rows.forEach(row => {
            this.exItem(row);
          });
          this.$emit('add-all-item', rows);
        }
      },
      addItem(row) {
        this.exItem(row);
        this.$emit('add-item', row);
      },
      exItem(row) {
        row.objectId = row.targetId;
        row.objectType = AdStrategyEnum.objectType.PRODUCT_TARGET;
        row.objectName = row.expressionValue;
        row.objectDisplayName = row.expressionValue;
        // row.bid = row.bid;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "common";

</style>
